import type { ProgressIndicatorElementProps } from './ProgressIndicator.types';

export function ProgressIndicatorElement(props: ProgressIndicatorElementProps) {
  const { element, currentProgress, attributes } = props;

  const { foregroundColor } = element.attrs || {};

  return (
    <div className="relative overflow-hidden h-1 w-full bg-transparent" {...attributes}>
      <div className="h-2 w-full" style={{ backgroundColor: foregroundColor, width: `${currentProgress}%` }} />
    </div>
  );
}
